import { db } from "../main";
import AES from "crypto-js/aes";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  setDoc,
  deleteDoc,
  Timestamp,
} from "firebase/firestore";

export async function hasUserSurvey(user) {
  const surveyCols = await getDocs(collection(db, "user", user.uid, "survey"));
  if (surveyCols.empty == false) {
    var hasSurvey = false;
    surveyCols.forEach((docSurvey) => {
      hasSurvey = hasSurvey || docSurvey.data().is_completed == false;
    });
    return hasSurvey;
  }
  return false;
}

export async function hasUserResult(user) {
  const surveyCols = await getDocs(collection(db, "user", user.uid, "survey"));
  if (surveyCols.empty == false) {
    var hasResult = false;
    surveyCols.forEach((docSurvey) => {
      hasResult = hasResult || docSurvey.data().is_completed == true;
    });
    return hasResult;
  }
  return false;
}

export async function addUserProfil(user, profil) {
  return await setDoc(
    doc(db, "user", user.uid),
    { profil: JSON.stringify(profil), position: profil.position },
    { merge: true }
  );
}
export async function hasUserProfil(user) {
  const userDoc = await getDoc(doc(db, "user", user.uid));
  if (userDoc.data() != undefined && userDoc.data().profil != undefined) {
    var profil = JSON.parse(userDoc.data().profil);
    return {
      hasProfil: true,
      position: userDoc.data().position,
      nameSurname: ComputeUserNameSurname(profil),
    };
  }
  return { hasProfil: false, position: undefined, nameSurname: undefined };
}

function ComputeUserNameSurname(profil) {
  return (
    profil.name.charAt(0).toUpperCase() +
    profil.name.slice(1) +
    " " +
    profil.surname.charAt(0).toUpperCase() +
    profil.surname.slice(1)
  );
}
export async function isSu(user) {
  const userDoc = await getDoc(doc(db, "user", user.uid));
  var data = {
    is_su: false,
    is_su_admin: false,
  };

  if (userDoc.data() != undefined) {
    if (userDoc.data().is_su == true) {
      data.is_su = true;
    }
    if (userDoc.data().is_su_admin == true) {
      data.is_su_admin = true;
    }
  }
  return data;
}
export async function getUserProfil(uid) {
  console.log(uid);
  if (uid != undefined) {
    const userDoc = await getDoc(doc(db, "user", uid));
    if (userDoc.data() != undefined && userDoc.data().profil != undefined) {
      return JSON.parse(userDoc.data().profil);
    }
  }
  return {};
}
export async function onUserLogged(user) {
  // new user create its db

  //const docRef = db.collection("user").doc(user.uid);

  var userAllowed = await getDoc(doc(db, "user_allowed", user.email));
  var is_su = false;
  if (userAllowed != undefined && userAllowed.data() != undefined) {
    is_su = userAllowed.data().is_su == true;
  }
  getDoc(doc(db, "user", user.uid)).then((userdb) => {
    if (userdb.exists() == false) {
      // Add a  user in db
      userdb = setDoc(doc(db, "user", user.uid), {
        email: user.email,
        is_su: is_su,
      });
    }
  });

  // get user survey
  const userCampaignCol = collection(
    db,
    "user_allowed",
    user.email,
    "campaign"
  );
  const userCampaigns = await getDocs(userCampaignCol);
  //foreach campaign afcamapginfected to the user
  for (var userCampaign of userCampaigns.docs) {
    var surveyCol = collection(db, "campaign", userCampaign.id, "survey");
    var snapShotSurvey = await getDocs(surveyCol);
    for (var docSurvey of snapShotSurvey.docs) {
      if (
        (
          await getDoc(doc(db, "user", user.uid, "survey", docSurvey.id))
        ).exists() == false
      ) {
        await setDoc(doc(db, "user", user.uid, "survey", docSurvey.id), {
          is_completed: false,
          idCampaign: userCampaign.id,
        });
      }
    } // rof each survey for users
  } // rof each campaing for user

  return is_su;
}

//////////////// survey
/*
export async function getSurveys(user) {
  var surveys = {};
  const snapShotSurvey = await getDocs(
    collection(db, "user", user.uid, "survey")
  );
  snapShotSurvey.forEach(async (docSurvey) => {
    surveys[docSurvey.id] = docSurvey.data();
  }); // rof each survey
  return surveys;
}*/
export async function getSurvey(type) {
  const docSurvey = await getDoc(doc(db, "survey", type));
  return docSurvey.data();
}

/////   user

export async function AddSuperUser(data) {
  await setDoc(doc(db, "user_allowed", data.email), { is_su: true });
}
////////////////// Campaign

export async function GetUserCampaigns(userData) {
  const snapShotCampaigns = await getDocs(
    collection(db, "user", userData.uid, "campaign")
  );
  var campaigns = {};
  snapShotCampaigns.forEach(async (docCampaign) => {
    campaigns[docCampaign.id] = docCampaign.data();
    campaigns[docCampaign.id].positions = "";
    const snapShotEmails = await getDocs(
      collection(db, "campaign", docCampaign.id, "answering")
    );
    snapShotEmails.forEach((snapEmail) => {
      if (snapEmail.data().position != undefined)
        campaigns[docCampaign.id].positions += snapEmail.data().position + ";";
    });
  }); // rof each survey
  return campaigns;
}
export async function GetUserCampaign(campaignId) {
  const docCampaign = await getDoc(doc(db, "campaign", campaignId));
  const snapShotEmails = await getDocs(
    collection(db, "campaign", campaignId, "answering")
  );
  const snapShotSurveys = await getDocs(
    collection(db, "campaign", campaignId, "survey")
  );

  var campaign = docCampaign.data();
  var surveys = [];
  campaign.surveys = {};
  snapShotSurveys.forEach(async (snapShotSurvey) => {
    surveys.push(snapShotSurvey.id);
    campaign.surveys[snapShotSurvey.id] = [];
  }); // rof each survey
  snapShotEmails.forEach(async (snapEmail) => {
    surveys.forEach((survey) => {
      campaign.surveys[survey].push({
        email: snapEmail.id,
        uid: snapEmail.data().uid,
        name: snapEmail.data().name,
        position: snapEmail.data().position,
        result: snapEmail.data()[survey],
      });
    });
  }); // rof each survey

  return campaign;
}
function generateUUID() {
  // Public Domain/MIT
  var d = new Date().getTime(); //Timestamp
  var d2 =
    (typeof performance !== "undefined" &&
      performance.now &&
      performance.now() * 1000) ||
    0; //Time in microseconds since page-load or 0 if unsupported
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = Math.random() * 16; //random number between 0 and 16
    if (d > 0) {
      //Use timestamp until depleted
      r = (d + r) % 16 | 0;
      d = Math.floor(d / 16);
    } else {
      //Use microseconds since page-load if supported
      r = (d2 + r) % 16 | 0;
      d2 = Math.floor(d2 / 16);
    }
    return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
  });
}

export async function AddCampaign(campaign, userUid, userMail) {
  // ajoute document dans campagn
  if (campaign.id == undefined) {
    campaign.id = generateUUID();
  }
  campaign.dateCreation = Timestamp.fromDate(new Date());
  await setDoc(doc(db, "campaign", campaign.id), {
    name: campaign.name,
    client: campaign.client,
    dateCreation: campaign.dateCreation,
    userShouldHaveResult: campaign.userShouldHaveResult,
    suMail: userMail,
  });

  // ajoute la campagn à l'utilisateur créateur (su)
  await setDoc(doc(db, "user", userUid, "campaign", campaign.id), {
    name: campaign.name,
    client: campaign.client,
    answerings: campaign.answerings,
    surveys: campaign.surveys,
    userShouldHaveResult: campaign.userShouldHaveResult,
    dateCreation: campaign.dateCreation,
  });

  // défini les utilisateurs pouvant accéder à la campagn
  campaign.answerings.split(";").forEach(async (email) => {
    await setDoc(doc(db, "campaign", campaign.id, "answering", email.trim()), {
      date: new Date(),
    });
    await setDoc(
      doc(db, "user_allowed", email.trim(), "campaign", campaign.id),
      {}
    );
  });
  campaign.surveys.split(";").forEach(async (survey) => {
    await setDoc(doc(db, "campaign", campaign.id, "survey", survey.trim()), {});
  });

  return campaign;
}
export async function DeleteCampaign(campaign, key, userUid) {
  await deleteDoc(doc(db, "user", userUid, "campaign", key));

  await deleteDoc(doc(db, "campaign", key));
}
export async function EditCampaign(campaignOldIn, campaignIn, key, userUid) {
  // ajoute document dans campagn
  var campaignOld = { ...campaignOldIn };
  var campaign = { ...campaignIn };
  await setDoc(
    doc(db, "campaign", key),
    {
      name: campaign.name,
      client: campaign.client,
      dateCreation: campaign.dateCreation,
      userShouldHaveResult: campaign.userShouldHaveResult,
    },
    { merge: true }
  );

  // ajoute la campagn à l'utilisateur créateur (su)
  await setDoc(
    doc(db, "user", userUid, "campaign", key),
    {
      name: campaign.name,
      client: campaign.client,
      answerings: campaign.answerings,
      surveys: campaign.surveys,
      userShouldHaveResult: campaign.userShouldHaveResult,
    },
    { merge: true }
  );

  campaign.answerings.split(";").forEach((email) => {
    if (email != ";") {
      campaignOld.answerings = campaignOld.answerings.replace(email, "");
    }
  });
  // remove old ( tout les email qui n'y sont plus)
  campaignOld.answerings.split(";").forEach(async (email) => {
    if (email.trim() != "" && email != ";") {
      await deleteDoc(doc(db, "campaign", key, "answering", email.trim()), {});

      await deleteDoc(doc(db, "user_allowed", email.trim(), "campaign", key));
    }
  });
  campaignOld.surveys.split(";").forEach(async (survey) => {
    await deleteDoc(doc(db, "campaign", key, "survey", survey.trim()));
  });
  // conserve que les nouveau email
  /*campaignOldIn.answerings.split(";").forEach((email) => {
    if (email != ";") {
      campaign.answerings = campaign.answerings.replace(email, "");
    }
  });*/
  // add new
  // défini les utilisateurs pouvant accéder à la campagn
  campaign.answerings.split(";").forEach(async (email) => {
    if (email.trim() != "") {
      await setDoc(
        doc(db, "campaign", key, "answering", email.trim()),
        {},
        {
          merge: true,
        }
      );
      await setDoc(
        doc(db, "user_allowed", email.trim(), "campaign", key),
        {},
        {
          merge: true,
        }
      );
    }
  });
  campaign.surveys.split(";").forEach(async (survey) => {
    await setDoc(
      doc(db, "campaign", key, "survey", survey.trim()),
      {},
      {
        merge: true,
      }
    );
  });

  return campaignIn;
}

/// survey answer
export async function addSurveyAnswers(type, user, answers) {
  await setDoc(
    doc(db, "user", user.uid, "survey", type),
    {
      is_completed: true,
      answers: JSON.stringify(answers),
    },
    { merge: true }
  );
  return true;
}

////////////////// Result
export async function addSurveyResult(type, user, results) {
  var userSurvey = await getDoc(doc(db, "user", user.uid, "survey", type));

  await setDoc(
    doc(db, "user", user.uid, "survey", type),
    {
      resultRef: results.resultRef,
      resultRadar: JSON.stringify(results.resultRadar),
      resultDetails: JSON.stringify(results.resultDetails),
      dateAnswering: Date(),
    },
    { merge: true }
  );

  await setDoc(
    doc(
      db,
      "campaign",
      userSurvey.data().idCampaign,

      "answering",
      user.data.email
    ),
    {
      name:
        user.data.displayName != undefined
          ? user.data.displayName
          : user.nameSurname,
      position: user.position != undefined ? user.position : "",
      [type]: results.resultRef,
      uid: AES.encrypt(user.uid, "turlututu2").toString(),
    },
    { merge: true }
  );

  var campaignDoc = await getDoc(
    doc(db, "campaign", userSurvey.data().idCampaign)
  );
  await setDoc(
    doc(db, "user", user.uid, "survey", type),
    {
      userShouldHaveResult: campaignDoc.data().userShouldHaveResult,
    },
    { merge: true }
  );

  return {
    suMail: campaignDoc.data().suMail,
    userShouldHaveResult: campaignDoc.data().userShouldHaveResult,
  };
}

export async function getSurveyResults(userId) {
  const surveyDocs = await getDocs(collection(db, "user", userId, "survey"));
  var surveyResults = surveyDocs.docs.map((docSurvey) => ({
    type: docSurvey.id,
    resultRef: docSurvey.data().resultRef,
    resultDetails:
      docSurvey.data().resultDetails != null
        ? docSurvey.data().resultDetails.replace("]", "").split(",")
        : [],
    userShouldHaveResult: docSurvey.data().userShouldHaveResult,
    resultRadar: JSON.parse(docSurvey.data().resultRadar),

    dateAnswering:
      docSurvey.data().dateAnswering != undefined
        ? docSurvey.data().dateAnswering
        : Date(),
  }));

  return surveyResults;
}

export async function getSurveyResultWithDetails(type, user) {
  const surveyDoc = await getDoc(doc(db, "user", user.uid, "survey", type));

  if (
    surveyDoc.data() != undefined &&
    surveyDoc.data().resultRef != undefined
  ) {
    return {
      resultRef: surveyDoc.data().resultRef,
      resultDetails: JSON.parse(surveyDoc.data().resultDetails),
    };
  }
  return undefined;
}
